import { render, staticRenderFns } from "./TabAttachments.vue?vue&type=template&id=aab42bd8&"
import script from "./TabAttachments.vue?vue&type=script&lang=js&"
export * from "./TabAttachments.vue?vue&type=script&lang=js&"
import style0 from "./TabAttachments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports